import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import Hello from './Hello';
import reportWebVitals from './reportWebVitals';
// import ErrorBoundaryComponent from './Errors/ErrorBoundary';

ReactDOM.render(
  <React.StrictMode>
    {/* <ErrorBoundaryComponent content={<App />} /> */}
    <App />
  </React.StrictMode>, 
  document.getElementById('root')
);

// let getProps = (elem) => {
//   let props = {}
//   for (let i in elem.attributes) {
//     let attr = elem.attributes[i];
//     if (attr.name && attr.name.startsWith("data-")) {
//       props[attr.name.substring(5)] = attr.value;
//     }

//   }
//   console.log("props", props);
//   return props;
// }
// function createElementFromHTML(htmlString) {
//   var div = document.createElement('div');
//   div.innerHTML = htmlString.trim();

//   // Change this to div.childNodes to support multiple top-level nodes.
//   debugger;
//   return div.firstChild;
// }

// ReactDOM.render(
//   <React.StrictMode>
//     {/* <ErrorBoundaryComponent content={<App />} /> */}
//     <Hello props={getProps(document.getElementById('roota'))}>OK Jo</Hello>
//   </React.StrictMode>, 
//   document.getElementById('roota')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
